import { useEffect, useState } from 'react';
import DOMPurify from 'dompurify';

export default function useSanitizedHtml(rawText) {
  const [sanitized, setSanitized] = useState(null);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const clean = DOMPurify.sanitize(rawText);

    setSanitized(clean);
  }, [rawText]);

  return sanitized;
}
